"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "app-startup-common",
    class: {
      'app-startup-common--closing': _vm.closing,
      'app-startup-common--no-bg': !_vm.backgroundImage
    },
    style: _vm.styleCommon
  }, [_c('div', {
    staticClass: "app-startup-common-section app-startup-common-section-connection"
  }, [_vm._t("connection")], 2), _c('div', {
    staticClass: "app-startup-common-section app-startup-common-section-info",
    style: _vm.styleInfo
  }, [_vm.infoContent ? _c('div', {
    staticClass: "app-startup-common-section-info-content",
    domProps: {
      "innerHTML": _vm._s(_vm.infoContent)
    }
  }) : _vm._e()]), _vm._m(0)]);
};
var staticRenderFns = exports.staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "app-fontawesome-preload"
  }, [_c('i', {
    staticClass: "fa fa-spinner",
    attrs: {
      "aria-hidden": "true"
    }
  })]);
}];